import { gql } from '@apollo/client';
import { QUOTE_CHANGELOG_VIEW_MODEL_FRAGMENT } from './fragments';
import { PAGINATION_VIEW_MODEL_FRAGMENT } from '../../../shared';

export const QUOTE_CHANGELOG_LIST = gql`
  query QuoteChangelogList($input: QuoteChangeLogListInput!) {
    quote {
      result: quoteChangelogList(input: $input) {
        error
        success
        pagination {
          ...PaginationMetaViewModel
        }
        items {
          ...QuoteChangelogViewModelFields
        }
      }
    }
  }
  ${QUOTE_CHANGELOG_VIEW_MODEL_FRAGMENT}
  ${PAGINATION_VIEW_MODEL_FRAGMENT}
`;
